interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  body?: string;
}

const SectionHeading = ({ eyebrow, title, body }: SectionHeadingProps) => (
  <header className="landing-section-heading">
    <p className="landing-eyebrow">{eyebrow}</p>
    <h2>{title}</h2>
    {body && <p>{body}</p>}
  </header>
);

export default SectionHeading;
